export async function runDelayImplementation(data: { duration: number }) {
  await new Promise((resolve) => setTimeout(resolve, data.duration));
}
